import { Component, inject, input } from '@angular/core';
import { FileUploadModule } from '@openng/optimus-ui/fileupload';
import { UserUploadSecretStore } from './user-upload-secret.store';
import { UserSecretTypeEnum } from '@libs/types/src/user/enum/user-secret-type.enum';
import { fb } from '../../../../modules/shared/shared.global-service';
import { Validators } from '@angular/forms';
import { DateInputComponent } from '../../../kit/input/date-input/date-input.component';
import { TextInputComponent } from '../../../kit/input/text-input/text-input.component';
import { PasswordInputComponent } from '../../../kit/input/password-input/password-input.component';

@Component({
    selector: 'app-user-upload-secret',
    imports: [FileUploadModule, DateInputComponent, PasswordInputComponent, TextInputComponent],
    templateUrl: './user-upload-secret.component.html',
    styleUrl: './user-upload-secret.component.scss',
    providers: [UserUploadSecretStore],
})
export class UserUploadSecretComponent {
    public readonly store = inject(UserUploadSecretStore);

    public userId = input<string | null>(null);

    protected formIdentity = fb.group({
        password: fb.control<string | null>(null, Validators.required),
        uuid: fb.control<string | null>(null, Validators.required),
        validTo: fb.control<Date | null>(null, Validators.required),
    });

    async save() {
        if (!this.formIdentity.isInvalid() && this.userId()) {
            const res = await this.store.api.createUserSecret({
                type: UserSecretTypeEnum.SUKL_IDENTITY,
                publicSecret: this.formIdentity.value.uuid!,
                privateSecret: this.formIdentity.value.password!,
                userId: this.userId()!,
                validTo: this.formIdentity.value.validTo!,
            });
            return res.ok;
        } else {
            return false;
        }
    }
}
